import { BElement } from "utils/base-component"

export class MobileDropdowns {
  private cssClass: string
  private forecastsBtn: BElement
  private forecastsDropdown: BElement
  private myMountainsBtn: BElement
  private myMountainsDropdown: BElement
  private settingsBtn: BElement
  private settingsDropdown: BElement

  constructor(cssClass: string) {
    this.cssClass = cssClass
    this.initializeElements()
    this.initializeDropdownStates()
    this.addEventListeners()
  }

  private initializeElements() {
    const forecastsBtn = document.querySelector(".menu-nav__button--forecasts")
    // console.log('Forecasts button found:', forecastsBtn) // Debug line
    this.forecastsBtn = new BElement(forecastsBtn, this.cssClass)

    const forecastsDropdown = document.querySelector(".menu-nav__forecasts-dropdown")
    // console.log('Forecasts dropdown found:', forecastsDropdown) // Debug line
    this.forecastsDropdown = new BElement(forecastsDropdown, this.cssClass)

    const myMountainsBtn = document.querySelector(".menu-nav__button--mymountains")
    // console.log('My Mountains button found:', myMountainsBtn) // Debug line
    this.myMountainsBtn = new BElement(myMountainsBtn, this.cssClass)

    const myMountainsDropdown = document.querySelector(".menu-nav__mymountains-dropdown")
    // console.log('My Mountains dropdown found:', myMountainsDropdown) // Debug line
    this.myMountainsDropdown = new BElement(myMountainsDropdown, this.cssClass)

    const settingsBtn = document.querySelector(".menu-nav__button--settings")
    // console.log('Settings button found:', settingsBtn) // Debug line
    this.settingsBtn = new BElement(settingsBtn, this.cssClass)

    const settingsDropdown = document.querySelector(".menu-nav__settings-dropdown")
    // console.log('Settings dropdown found:', settingsDropdown) // Debug line
    this.settingsDropdown = new BElement(settingsDropdown, this.cssClass)
  }

  private initializeDropdownStates() {
    // Set initial dropdown state
    if (this.forecastsBtn.element) {
      this.forecastsBtn.element.setAttribute("aria-expanded", "true")
      this.forecastsDropdown.element?.classList.add("active")
    }
    if (this.myMountainsBtn.element) {
      this.myMountainsBtn.element.setAttribute("aria-expanded", "false")
    }
    if (this.settingsBtn.element) {
      this.settingsBtn.element.setAttribute("aria-expanded", "false")
    }
  }

  private addEventListeners() {
    if (this.forecastsBtn.element) {
      this.forecastsBtn.element.addEventListener("click", (e) => {
        e.preventDefault()
        this.toggleDropdown(this.forecastsDropdown, this.forecastsBtn)
      })
    }

    if (this.myMountainsBtn.element) {
      this.myMountainsBtn.element.addEventListener("click", (e) => {
        e.preventDefault()
        this.toggleDropdown(this.myMountainsDropdown, this.myMountainsBtn)
      })
    }

    if (this.settingsBtn.element) {
      this.settingsBtn.element.addEventListener("click", (e) => {
        e.preventDefault()
        this.toggleDropdown(this.settingsDropdown, this.settingsBtn)
      })
    }
  }

  private toggleDropdown(dropdown: BElement, button: BElement): void {
    if (!dropdown?.element || !button?.element) return

    const dropdownElement = dropdown.element
    const buttonElement = button.element
    const isExpanded = buttonElement.getAttribute("aria-expanded") === "true"

    // first close all dropdowns
    this.closeAllDropdowns(dropdown)

    // Toggle dropdown state
    if (isExpanded) {
      dropdownElement.classList.remove("active")
      buttonElement.setAttribute("aria-expanded", "false")
      const arrowIcon = buttonElement.querySelector(".menu-nav__down-arrow-icon")
      if (arrowIcon) {
        arrowIcon.classList.remove("active")
      }
    } else {
      dropdownElement.classList.add("active")
      buttonElement.setAttribute("aria-expanded", "true")
      const arrowIcon = buttonElement.querySelector(".menu-nav__down-arrow-icon")
      if (arrowIcon) {
        arrowIcon.classList.add("active")
      }
    }
  }

  // Public method to check if click is inside dropdowns
  isDropdownClick(target: Node): boolean {
    return (
      (this.forecastsDropdown.element && this.forecastsDropdown.element.contains(target)) ||
      (this.myMountainsDropdown.element && this.myMountainsDropdown.element.contains(target)) ||
      (this.settingsDropdown.element && this.settingsDropdown.element.contains(target))
    )
  }

  // Public method to check if click is on dropdown buttons
  isDropdownButtonClick(target: Node): boolean {
    return (
      (this.forecastsBtn.element && this.forecastsBtn.element.contains(target)) ||
      (this.myMountainsBtn.element && this.myMountainsBtn.element.contains(target)) ||
      (this.settingsBtn.element && this.settingsBtn.element.contains(target))
    )
  }

  // Public method to close all dropdowns
  closeAllDropdowns(exceptDropdown?: BElement): void {
    const dropdowns = [
      { dropdown: this.forecastsDropdown, button: this.forecastsBtn },
      { dropdown: this.myMountainsDropdown, button: this.myMountainsBtn },
      { dropdown: this.settingsDropdown, button: this.settingsBtn },
    ]

    dropdowns.forEach(({ dropdown, button }) => {
      if (exceptDropdown && dropdown === exceptDropdown) return

      if (dropdown?.element && button?.element) {
        if (dropdown.element.classList.contains("active")) {
          dropdown.element.classList.remove("active")
          button.element.setAttribute("aria-expanded", "false")
        }

        const arrowIcon = button.element.querySelector(".menu-nav__down-arrow-icon")
        if (arrowIcon) {
          arrowIcon.classList.remove("active")
        }
      }
    })
  }

  // Public method to check if any mobile dropdowns are currently open
  hasOpenDropdowns(): boolean {
    return (
      (this.forecastsDropdown.element &&
        this.forecastsDropdown.element.classList.contains("active")) ||
      (this.myMountainsDropdown.element &&
        this.myMountainsDropdown.element.classList.contains("active")) ||
      (this.settingsDropdown.element && this.settingsDropdown.element.classList.contains("active"))
    )
  }
}
